import { CommonTooltips } from "@mcleod/common";
import {AutogenLayoutFuelTransactionsProcessingHold} from "./autogen/AutogenLayoutFuelTransactionsProcessingHold";
import {DataSourceExecutionEvent, TableRowDisplayEvent} from "@mcleod/components";

export class FuelTransactionsProcessingHold extends AutogenLayoutFuelTransactionsProcessingHold {

    /** This is an event handler for the beforeExecution event of sourceFuelDetail. */
    sourceFuelDetailBeforeExecution(event: DataSourceExecutionEvent) {
        event.filter.is_hold = "Y";
    }

    /** This is an event handler for the onRowDisplay event of tableFuelTransactions. */
    tableFuelTransactionsOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const labelChainCode = tableRow.findComponentById("labelChainCode");
        CommonTooltips.setTooltipContentLayout(labelChainCode, null, "lme/integrations/fuel/FuelChainCodeQuickInfo", null,
            { interface_id: tableRow.data.get("interface_id"), code: tableRow.data.get("chain_code") }
        );
    }
}
